// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateIsEditable = isEditable => ({
    isEditable,
    type: actions.UPDATE_CLAIM_SPA_IS_EDITABLE
});



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/is-editable.js